export default __webpack_public_path__ + "static/media/games_dark.2d144505.png";